import { getProjectsByUserId } from '../projects'
import type { Project } from '../projects.type'

let inFlight: Promise<Project[]> | null = null

export function resetProjectsFetchDedupedInFlight(): void {
  inFlight = null
}

/**
 * Deduplicates concurrent calls to the session-scoped GetProjectsByUserId fetch while the list
 * is being loaded (e.g. Strict Mode double effects + init + page effects).
 */
export function getProjectsByUserIdDeduped(): Promise<Project[]> {
  if (!inFlight) {
    inFlight = getProjectsByUserId().finally(() => {
      inFlight = null
    })
  }
  return inFlight
}
